import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { uniqueId } from 'lodash'

import { Button } from '@/components/atoms/Button'
import { TippingModal } from '@/components/pages/UserProfile/components/TippingModal'

interface TopSupportersTipProps {
  entryAmountRPK: number
  username: string
  userId: string
}

export default function TopSupportersTip({
  entryAmountRPK,
  username,
  userId,
}: TopSupportersTipProps) {
  const { t } = useTranslation()
  const uuid = useMemo(() => uniqueId(), [])

  return (
    <div className="text-center px-[15%] mt-8">
      <p className="text-sm">
        <Trans
          i18nKey={'topSupporters.tipDescription'}
          components={{
            amount: <span className="font-bold text-primary" />,
          }}
          values={{ username: `@${username}`, rpkAmount: entryAmountRPK }}
        />
      </p>

      <Button id={`send-tip-button-${uuid}`} className="mt-4">
        {t('tip.actions.sendTip')}
      </Button>

      <TippingModal
        userId={userId}
        initialAmount={entryAmountRPK}
        uuid={uuid}
      />
    </div>
  )
}
